import { ReactElement, useMemo } from "react";
import { View } from "react-native";
import { FlatList } from "react-native-gesture-handler";
import Header from "src/components/Header";
import ListFooterComponent from "src/components/ListFooterComponent";
import Search from "src/components/Search";
import SearchNoResults from "src/components/SearchNoResults";
import { useTrunkLeafNavigationRouter } from "src/components/TrunkLeafNavigation";
import useDevice from "src/hooks/useDevice";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { radiusMedium } from "src/styles/radius";
import { paddingXL, paddingXXL } from "src/styles/spacing";
import { UseGatheringAndUsersForFilterModal_User } from "../hooks/useGatheringUsersForFilter";

const GatheringFilterSortSeeAll = ({
	testID,
	headerText,
	users,
	renderItem,
	handleSearchInput,
	onEndReached,
	onRefresh,
	refreshing,
	loading = false,
}: {
	testID?: string;
	headerText: string;
	users: UseGatheringAndUsersForFilterModal_User[];
	renderItem: ({ item }: { item: UseGatheringAndUsersForFilterModal_User }) => ReactElement;
	handleSearchInput: (searchInput: string) => void;
	onEndReached?: () => void;
	onRefresh?: () => void;
	refreshing?: boolean;
	loading?: boolean;
}) => {
	const { device } = useDevice();
	const { theme } = useStyle();
	const paddingHorizontal = useMemo(
		() => (device === "mobile" ? paddingXL : paddingXXL),
		[device],
	);
	const router = useTrunkLeafNavigationRouter();

	return (
		<View
			testID={testID}
			style={{
				height: "100%",
				width: "100%",
			}}
		>
			<Header
				completeVariant="None"
				exitVariant="Arrow"
				onExit={() => {
					router?.navigateToTrunk();
				}}
				variant="Modal"
			>
				{headerText}
			</Header>
			<View
				style={{
					flex: 1,
					rowGap: paddingXXL,
					paddingHorizontal,
				}}
			>
				<View style={{ alignItems: "center", height: 48 }}>
					<Search
						onDebouncedChangeText={handleSearchInput}
						style={{ maxWidth: "100%" }}
					/>
				</View>
				<FlatList
					showsVerticalScrollIndicator={false}
					contentContainerStyle={{
						borderRadius: radiusMedium,
						overflow: "hidden",
					}}
					data={users}
					renderItem={renderItem}
					keyExtractor={(item) => item.userId}
					onEndReachedThreshold={0.5}
					onEndReached={onEndReached}
					refreshing={refreshing}
					onRefresh={onRefresh}
					ListFooterComponent={<ListFooterComponent loading={loading} />}
					ListEmptyComponent={
						<SearchNoResults style={{ marginHorizontal: -paddingHorizontal }} />
					}
					ItemSeparatorComponent={() => (
						<View style={{ height: 1, backgroundColor: color.Neutral[theme] }} />
					)}
				/>
			</View>
		</View>
	);
};

export default GatheringFilterSortSeeAll;
